import { scroll, animate } from "motion";
//
// const desktopVideo = document.querySelector('.scrub-video-section .background-video #bg-video');
// const headings = document.querySelectorAll('.scrub-video-section .overlay .items');
// desktopVideo.pause();
// scroll(
//     ({ y }) => {
//         if (!desktopVideo.readyState) return;
//
//         if (y.progress > 0.99) {
//             return;
//         } else {
//             desktopVideo.currentTime = desktopVideo.duration * y.progress;
//         }
//     },
//     {
//         target: document.querySelector('.scrub-video-section'),
//         offset: ['start start', 'end end'],
//     },
// );

// if (!desktopVideo) {
//     console.error("Video element not found!");
// } else {
//     desktopVideo.pause();
//     desktopVideo.addEventListener('loadedmetadata', () => {
//
//         // Attempt to play the video (some browsers require user interaction)
//         // desktopVideo.play().catch(error => console.error("Autoplay prevented:", error));
//
//         scroll(
//             (progress) => {  // 'progress' is just a number (0 to 1)
//
//                 if (desktopVideo.readyState < 2) return; // Ensure video is loaded
//                 desktopVideo.currentTime = desktopVideo.duration * progress;
//             },
//             {
//                 target: document.querySelector('.scrub-video-section'),
//                 offset: ['start start', 'end end'],
//             },
//         );
//     });
// }
desktopAnimations();

function desktopAnimations() {
    const items = Array.from(document.querySelectorAll('.scrub-video-section .overlay .item'));
    const states = items.map((_, i) => (i === 0 ? true : false));
    const itemsProxy = new Proxy(states, {
        set: (target, prop, value) => {
            target[prop] = value;

            // update nav active state
            let activeIndex = 0;
            for (let i = 0; i < target.length; i++) {
                if (target[i]) {
                    activeIndex = i;
                }
            }
            return true;
        }
    });
    items.forEach((item, i) => {
        // fade in/out text desktop
        scroll(animate(item, { opacity: [0, 1, 1, 0] }), {
            target: item.firstElementChild,
        });

        // update section's nav when item is scrolled into view
        scroll(
            (progress) => {  // 'progress' is just a number

                if (progress === 1) {
                    if (itemsProxy[i]) return;
                    itemsProxy[i] = true;
                } else {
                    if (!itemsProxy[i]) return;
                    itemsProxy[i] = false;
                }
            },
            {
                target: item.firstElementChild,
                offset: ['1 0.75', '1 0.65'],
            }
        );
    });
}

jQuery(document).ready( function($) {
    function checkVisibility() {
        $(".wp-block-group").each(function () {
            let elementTop = $(this).offset().top;
            let elementHeight = $(this).outerHeight();
            let elementMid = elementTop + elementHeight / 2;
            let windowTop = $(window).scrollTop();
            let windowBottom = windowTop + $(window).height();

            if (elementMid < windowBottom) {
                $(this).addClass("visible");
            }
        });
    }

    // Run on scroll and on page load
    $(window).on("scroll", checkVisibility);
    checkVisibility();
    $('.columns-expanding-text-section .column-button').on('click', function(){
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $(this).children('.expand').html('&ndash;');
        } else {
            $(this).children('.expand').html('&plus;');
        }
        $(this).siblings('.column-description').slideToggle();
    });
    if ( $('body .sustainable-goals-section').length > 0 ) {
        $('.sustainable-goals-carousel-container').slick({
            // centerMode: true,
            // centerPadding: "0px",
            dots: true,
            infinite: true,
            slidesToShow: 5.5,
            swipeToSlide: true,
            // slidesToScroll: 5,
            // focusOnSelect: true,
            adaptiveHeight: true,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4.5,
                        slidesToScroll: 3,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3.5,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2.15,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }
    
    if ( $('body .partners-tabs').length > 0 ) {
        $('.partners-descriptions-carousel').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,

        });
        $('.partners-slides').slick({
            centerMode: true,
            centerPadding: "0px",
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            focusOnSelect: true,
            adaptiveHeight: true,
            autoplay: false,
            swipe: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1.25,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.partners-nav-button').on('click', function() {
           const slideIndex = $(this).data('slide');
           $('.partners-descriptions-carousel').slick('slickGoTo', slideIndex);
           $('.partners-slides').slick('slickGoTo', slideIndex);

            $('.partners-nav-button').removeClass('active');
            $(this).addClass('active');
        });
        $('.partners-descriptions-carousel').on('afterChange', function (event, slick, currentSlide) {
            $('.partners-nav-button').removeClass('active');
            $(`.partners-nav-button[data-slide="${currentSlide}"]`).addClass('active');
        });
    }
    if ( $('body .impact-gallery-section').length > 0 ) {
        let isDown = false;
        let startX;
        let scrollLeft;

        const $gallery = $('.impact-gallery');

        // Desktop: Mouse Events
        $gallery.on('mousedown', function (e) {
            isDown = true;
            $gallery.addClass('active');
            startX = e.pageX - $gallery.offset().left;
            scrollLeft = $gallery.scrollLeft();
        });

        $(document).on('mouseup', function () {
            isDown = false;
            $gallery.removeClass('active');
        });

        $gallery.on('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - $gallery.offset().left;
            const walk = (x - startX) * 2; // Adjust scroll speed
            $gallery.scrollLeft(scrollLeft - walk);
        });

        // Mobile: Touch Events
        let touchStartX = 0;
        let touchScrollLeft = 0;

        $gallery.on('touchstart', function (e) {
            touchStartX = e.touches[0].pageX;
            touchScrollLeft = $gallery.scrollLeft();
        });

        $gallery.on('touchmove', function (e) {
            e.preventDefault();
            const touchX = e.touches[0].pageX;
            const walk = (touchX - touchStartX) * 2; // Adjust scroll speed
            $gallery.scrollLeft(touchScrollLeft - walk);
        });
    }
    if ( $('body .stories-container').length > 0 ) {
        $('.stories-container').slick({
            dots: false,
            infinite: false,
            slidesToShow: 3.5,
            slidesToScroll: 4,
            autoplay: false,
            // mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1.95,
                        slidesToScroll: 3,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.75,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.15,
                        slidesToScroll: 1
                    }
                }
            ],
        });
    }
    $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop();
        $('.parallax-img').css('transform', 'translateY(' + scrollTop * 0.4 + 'px)');
    });
});